import { Title } from "@solidjs/meta";
import type { ParentComponent } from "solid-js";

export const MetaTitleWithSeparator: ParentComponent = (props) => {
  return <Title>{props.children} | Sevedemo</Title>;
};
